// constants
import { SET_PLATFORM } from './platform-selection.constants';
import { PLATFORM_TYPES } from '@sitegen/common/constants/platforms';
import { setPlatform } from './platform-selection.actions';

export type PlatformState = PLATFORM_TYPES | '';

type Action = ReturnType<typeof setPlatform>;

export const initialState: PlatformState = '';

export const reducerKey: string = 'platform';

export const platformSelection = (state: PlatformState = initialState, action: Action): PlatformState => {
    switch (action.type) {
    case SET_PLATFORM:
        return action.payload;
    default:
        return state;
    }
};

export default platformSelection;
